import React, { useState } from 'react';
import { Box, IconButton, Menu, Divider, Tooltip, Link, Typography, Button } from '@mui/material';
import { Notification } from 'iconsax-react';
import styles from './header.module.scss';
import AcceptModal from './accept-modal';
import ReactTimeAgo from 'react-time-ago';
import { getNameFromProfile } from '../../utils/profile-utils';
import DenyModal from '../notifications/deny-modal';

const NotificationPopUp = ({ uiStore }) => {
    const { notifications } = uiStore;
    const [notification, setNotification] = React.useState(null);
    const [showAccpetModal, setShowAccpetModal] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [showDenyModal, setShowDenyModal] = useState(false);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const selectNoti = (noti) => {
        setNotification(noti);
        setShowAccpetModal(true);
    }

    const denyNoti = (noti) => {
        setNotification(noti);
        setShowDenyModal(true);
    }

    const deny = async (id) => {
        await uiStore.deny(id);
    }

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title="Notifications">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <Notification
                            size="24"
                            variant="Bulk"
                        />
                        {!!notifications?.length &&
                            <span className={styles.redDot}></span>
                        }
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        borderRadius: "8px",
                        width: '375px',
                        boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.07)',
                        paddingTop: 0
                    },
                }}
            >
                <Box className={styles.notificationBtn}>
                    <Typography sx={{ ml: 2 }} fontWeight='600'>Notifications</Typography>
                    <Link href='/notifications' sx={{ mr: 2 }} fontSize='12px' color='#888888'>See more</Link>
                </Box>

                {notifications?.slice(0, 5).filter(i => !i.read && !i.archived).map(noti => (
                    <Box key={noti._id}>
                        <Box className={styles.notificationItem}>
                            <img src={noti.notificationType === 'request' ? noti.requestingProfiles[0]?.image : noti.profilesRequested[0]?.image} alt='person' />
                            <Box>
                                {noti.notificationType === 'request' ?
                                    <Typography fontSize='12px'><b>{getNameFromProfile(noti.requestingProfiles[0])}</b> asks you for access to
                                        <b>{noti.profilesRequested.map(i => ' ' + i.name + ',')}/s</b></Typography>
                                    :
                                    <Typography fontSize='12px'><b>{getNameFromProfile(noti.profilesRequested[0])}</b> Granted you access to <b>{noti?.profilesRequested.map(i => <span key={i._id}>{i.name}, </span>)} card/s</b></Typography>
                                }

                                {noti.notificationType === 'request' && noti.message &&

                                    <Box
                                        sx={{
                                            whiteSpace: 'pre-line', backgroundColor: '#E3E8EF', borderRadius: '16px', p: 2,
                                            fontSize: '12px', maxWidth: '80%'
                                        }}
                                        className='notification-request-message'
                                    >
                                        {noti.message}
                                    </Box>
                                }
                                <Typography color='#0090FF' fontSize='12px'><ReactTimeAgo date={noti.createdDate} locale="en-US" /></Typography>

                                {noti.notificationType === 'request' &&
                                    <Box className={styles.notificationActions} sx={{ mb: 1 }}>
                                        <Button color='secondary' sx={{ mr: 1 }} onClick={() => selectNoti(noti)} variant="contained">Accept</Button>
                                        <Button variant="outlined" color='grey' onClick={() => denyNoti(noti)} >Deny</Button>
                                    </Box>
                                }
                            </Box>
                        </Box>
                        <Divider sx={{ margin: '4px auto', width: '90%' }} />
                    </Box>
                ))}

            </Menu>

            {
                notification &&
                <AcceptModal show={showAccpetModal} setShow={setShowAccpetModal} notification={notification} uiStore={uiStore} />
            }
            {notification &&
                <DenyModal show={showDenyModal} setShow={setShowDenyModal} notification={notification} uiStore={uiStore} deny={deny} />
            }
        </>
    )
}

export default NotificationPopUp;